import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import eyeIcon from '@/assets/svg/eye-icon.svg';
import eyeOffIcon from '@/assets/svg/eye-off-icon.svg';
import { useLoginForm } from '@/hooks/auth/useLoginForm';

export const LoginForm = () => {
  const { t } = useTranslation();
  const { credentials, isLoading, error, handleInputChange, handleSubmit } = useLoginForm();
  const [isPasswordVisible, setIsPasswordVisible] = useState(true);
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  const onSubmit = (e: React.FormEvent) => {
    void handleSubmit(e);
  };

  const togglePasswordVisibility = () => {
    setIsPasswordVisible((prev) => !prev);
  };

  return (
    <form className="form-stack" noValidate onSubmit={onSubmit}>
      <div className="field-group">
        <label className="field-label" htmlFor="loginId">
          {t('login.email')}
        </label>
        <input
          id="loginId"
          name="loginId"
          type="text"
          className={`field-input ${error ? 'field-input-error' : ''}`}
          autoComplete="username"
          value={credentials.username}
          onChange={(e) => handleInputChange('username', e.target.value)}
          data-testid="loginId-input"
          placeholder={t('login.emailPlaceholder')}
        />
      </div>

      <div className="field-group">
        <label className="field-label" htmlFor="password">
          {t('login.password')}
        </label>
        <div className={`input-with-icon ${error ? 'field-input-error' : ''}`}>
          <input
            id="password"
            name="password"
            type={!isMounted ? 'password' : isPasswordVisible ? 'text' : 'password'}
            className="field-input field-input-naked"
            autoComplete="current-password"
            value={credentials.password}
            onChange={(e) => handleInputChange('password', e.target.value)}
            data-testid="password-input"
          />
          <button
            type="button"
            className="field-icon-button"
            onClick={togglePasswordVisibility}
            aria-label={isPasswordVisible ? 'パスワードを非表示' : 'パスワードを表示'}
          >
            <img aria-hidden="true" className="field-icon" src={isPasswordVisible ? eyeIcon : eyeOffIcon} alt="" />
          </button>
        </div>
      </div>

      {error && <p className="field-error">{error}</p>}

      <button className="primary-action" type="submit" disabled={isLoading}>
        {t('header.login_button')}
      </button>
    </form>
  );
};
